﻿import { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from "react";
import { IDoesFilterPassParams, IFilterParams } from "@ag-grid-community/core";
import { Box, Select } from "@chakra-ui/react";
import { EmploymentStatus, displayEmploymentStatus } from "../../../../api/models/EntityCandidate";

const EmploymentStatusFilter = forwardRef((props: IFilterParams<{ status: EmploymentStatus }>, ref) => {
    const [filterValue, setFilterValue] = useState<EmploymentStatus | undefined>();

    const filterOptions = useMemo(
        () =>
            Object.keys(EmploymentStatus)
                .map(value => value as EmploymentStatus)
                .map(status => (
                    <option key={status} value={status}>
                        {displayEmploymentStatus(status)}
                    </option>
                )),
        []
    );

    useImperativeHandle(ref, () => {
        return {
            doesFilterPass(params: IDoesFilterPassParams<{ status: EmploymentStatus }>) {
                if (filterValue === undefined) {
                    return true;
                }
                return params.data.status === filterValue;
            },

            isFilterActive() {
                return filterValue !== undefined;
            },

            getModel() {
                if (!this.isFilterActive()) {
                    return null;
                }
                return { filterType: "text", type: "equals", filter: filterValue };
            },

            setModel(model: any) {
                const value = model == null ? undefined : model.filter || model.value;
                if (value !== filterValue) {
                    setFilterValue(value);
                }
            },
        };
    });

    useEffect(() => {
        props.filterChangedCallback();
    }, [filterValue]);

    return (
        <Box p={2}>
            <Select
                size="sm"
                value={filterValue ?? ""}
                onChange={event => {
                    const val = event.target.value;
                    setFilterValue(val === "" ? undefined : (val as EmploymentStatus));
                }}
            >
                <option value="">All</option>
                {filterOptions}
            </Select>
        </Box>
    );
});

export default EmploymentStatusFilter;
